// src/pages/MedicalCaseDiscussions/components/GoLiveCard.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import "./Golivecard.css";

const IGoLive = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="mcd-live-icon lucide lucide-radio-icon lucide-radio"><path d="M16.247 7.761a6 6 0 0 1 0 8.478"/><path d="M19.075 4.933a10 10 0 0 1 0 14.134"/><path d="M4.925 19.067a10 10 0 0 1 0-14.134"/><path d="M7.753 16.239a6 6 0 0 1 0-8.478"/><circle cx="12" cy="12" r="2"/></svg>
);

export default function GoLiveCard({ onStartLiveStream }) {
  const { t } = useTranslation();

  return (
    <div className="mcd-golive">
      <div className="mcd-golive__badge">
      
        <span className="mcd-golive__badge-label">  <span className="mcd-golive__badge-icon">
          <IGoLive />
        </span>{t("caseDiscussions.live") || "LIVE"} </span>
      </div>

      <h3 className="mcd-golive__title">
        {t("caseDiscussions.goLiveTitle") || "Go Live"}
      </h3>
      <p className="mcd-golive__desc">
        {t("caseDiscussions.goLiveDesc") ||
          "Stream a live case presentation and interact with colleagues in real-time."}
      </p>

      <button className="mcd-golive__cta" type="button" onClick={onStartLiveStream}>
        <IGoLive />
        {t("caseDiscussions.startLiveStream") || "Start Live Stream"}
      </button>
    </div>
  );
}